// extracted by mini-css-extract-plugin
module.exports = {"root":"Circle-module--root--2a4CV","image":"Circle-module--image--3Cm2p","isVisible":"Circle-module--is-visible--h_wNO","mask":"Circle-module--mask--2Kk5j"};